var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    clipPath: "url(#clip0_4108_7194)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.93294 1.40039L3.26628 1.40039C2.62461 1.40039 2.10544 1.92539 2.10544 2.56706L2.09961 11.9004C2.09961 12.5421 2.61878 13.0671 3.26044 13.0671L10.2663 13.0671C10.9079 13.0671 11.4329 12.5421 11.4329 11.9004L11.4329 4.90039L7.93294 1.40039ZM9.09961 10.7337L4.43294 10.7337L4.43294 9.56706L9.09961 9.56706L9.09961 10.7337ZM9.09961 8.40039L4.43294 8.40039L4.43294 7.23372L9.09961 7.23372L9.09961 8.40039ZM7.34961 5.48372L7.34961 2.27539L10.5579 5.48372L7.34961 5.48372Z",
    fill: "#605D62"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4108_7194"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 14) rotate(-90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.3944613fcbfacf5c42375433f7245640.svg";
export { ForwardRef as ReactComponent };